import React, { PropsWithChildren, ReactElement } from "react";

export default function Panel(props: PropsWithChildren): ReactElement {
  const { children } = props;

  return (
    <div className="shadow-xl flex h-full w-full flex-col rounded-xl bg-white">
      {children}
    </div>
  );
}
